import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import { enabledAbnormalOrderNotification, ShopAdvancedSettingDto } from "@/services/api/shop";
import { useGlobalStore } from "@/store/hooks";
import { useRequest } from "ahooks";
import { message, Radio, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface TipModalSettingProps {
    shopSetting: ShopSettingDTO;
    shopAdvancedSetting: ShopAdvancedSettingDto;
}

const TipModalSetting: React.FC<TipModalSettingProps> = function (props) {
    const { shopSetting, shopAdvancedSetting } = props;
    const { id: shopId } = shopSetting;

    const globalStore = useGlobalStore();
    const { shopAdvancedSettingStore } = globalStore;

    const { runAsync: handleAbnormalCheckHoursAfterOrderShipped, loading } = useRequest(
        async (enabled: boolean) => {
            const setting = await enabledAbnormalOrderNotification(shopId, enabled);

            shopAdvancedSettingStore.setAdvancedSetting(shopId, setting);

            message.success("设置成功");
        },
        {
            manual: true,
            debounceWait: 500,
        },
    );

    return (
        <Spin spinning={loading}>
            <div
                style={{
                    background: "#fafafa",
                    padding: 12,
                    borderRadius: 4,
                    marginBottom: 24,
                }}
            >
                <Radio.Group
                    defaultValue={shopAdvancedSetting.enabledAbnormalOrderNotification ?? true}
                    onChange={(e) => handleAbnormalCheckHoursAfterOrderShipped(e.target.value)}
                >
                    <Radio value={true}>有异常订单时，弹出提醒弹窗，并且不自动关闭弹窗</Radio>
                    <Radio value={false}>有异常订单时，不弹出提醒弹窗</Radio>
                </Radio.Group>
            </div>
        </Spin>
    );
};

export default observer(TipModalSetting);
